(function () {
  /* 20-sep-2026 - Reemplazo del cart-upsell.js que traia el tema.

     El original hacia dos cosas:

     1. Envolver las lineas del carrito en .cart-drawer-items-wrapper, que es el
        div que hace scroll dentro del carrito. Eso si se usa y se mantiene aca.

     2. Copiar una lista de productos recomendados desde #cart-drawer-upsell-wrapper
        y, cada vez que cambiaba el carrito, VOLVER A DESCARGAR LA PAGINA ENTERA
        para sacar ese bloque de ahi. En esta tienda ese bloque no existe, asi que
        no copiaba nada: solo dejaba un error en consola y, en cada "agregar al
        carrito", se bajaban unas 6 copias completas de la ficha (medio mega cada
        una). Eso es lo que se saco.

     Si algun dia activas el upsell propio del tema, hay que volver a poner el
     archivo original (esta en cualquiera de los temas viejos guardados). */

  function envolver() {
    if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return;
    var items = document.querySelector('#CartDrawer cart-drawer-items');
    if (!items || items.classList.contains('is-empty')) return;
    var wrapper = document.createElement('div');
    wrapper.classList.add('cart-drawer-items-wrapper');
    items.parentNode.insertBefore(wrapper, items);
    wrapper.appendChild(items);
  }

  envolver();

  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    var timer = null;
    new MutationObserver(function () {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(envolver, 100);
    }).observe(drawer, { childList: true, subtree: true });
  }
})();